import { paginationSize } from '../../../constants/constants';
import { SET_DEFAULT_CONFIGURATIONS } from '../../actions';
import {
    FETCH_PARKED_START,
    FETCH_PARKED_SUCCESS,
    FETCH_PARKED_ERROR,
    SET_PARKED_FILTER,
    SET_PARKED_PAGINATION,
    VIEW_PARKED_VISIT_LOADING_END,
    VIEW_PARKED_VISIT_LOADING_START,
    RESET_PARKED_FILTER,
    SET_PARKED_AUTO_NEXT_VISIT
} from '../../actions/mis/parkedAction';

const INIT_STATE = {
    error: "",
    loading: false,
    submitting: false,
    message: '',
    pagination: {
        currentPage: 1,
        pageSize: paginationSize,
        totalPages: 0,
        totalItems: 0,
    },
    parked: [],
    searchFilter: {
        searchText: "",
        risId: 1,
        mipIds: [],
        modalityIds: [],
        startDate: null,
        endDate: null,
    },
    sortConditions: [{ sortBy: "priority", dataType: "STRING", sortType: "asc" }],
    skippedVisits: [],
    autoNextVisit: false,
};

const parkedReducer = (state = INIT_STATE, action) => {
    let newState;
    let index;
    let searchFilter;
    switch (action.type) {
        case SET_DEFAULT_CONFIGURATIONS: {
            searchFilter = {
                ...INIT_STATE.searchFilter,
                risId: action.configurations.default_ris_id || 1,
                mipIds: action.configurations.default_mip_id ? [action.configurations.default_mip_id] : [],
                myCasesOnly: action.configurations.show_my_cases_only,
            };
            return { ...state, searchFilter };
        }
        case FETCH_PARKED_START: {
            return { ...state, error: '', message: '', loading: true };
        }
        case FETCH_PARKED_SUCCESS: {
            return { ...state, error: '', message: '', loading: false, parked: action.parked };
        }
        case FETCH_PARKED_ERROR: {
            return { ...state, loading: false, error: action.error, message: '' };
        }
        case SET_PARKED_PAGINATION: {
            return { ...state, pagination: action.pagination };
        }
        case SET_PARKED_FILTER: {
            newState = { ...state };
            newState.searchFilter = { ...action.payload.searchFilter }
            newState.sortConditions = action.payload.sortConditions.length > 0 ? [...action.payload.sortConditions] : []
            newState.skippedVisits = action.payload.skippedVisits.length > 0 ? [...action.payload.skippedVisits] : []
            return {
                ...newState
            }
        }
        case VIEW_PARKED_VISIT_LOADING_START: {
            return { ...state, loading: true };
        }
        case VIEW_PARKED_VISIT_LOADING_END: {
            return { ...state, loading: false };
        }
        case RESET_PARKED_FILTER: {
            newState = { ...state };
            newState.searchFilter.searchText = null;
            newState.searchFilter.startDate = null;
            newState.searchFilter.endDate = null;
            return { ...newState };
        }
        case SET_PARKED_AUTO_NEXT_VISIT: {
            return { ...state, autoNextVisit: action.autoNextVisit };
        }
        default:
            return state;
    }
}

export default parkedReducer;
